import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
export interface BookModel {
  id: number;
  langageRef: string;
  descriptionlan: string;
  title: string;
  url_image: string;
  url_book: string;
  url_audio: string;
}

export interface BookResponse {
  listBookModel: BookModel[];
  totalPages: number;
  totalElements: number;
  sizePage: number;
}
export interface GradeResponseContent {
  active: boolean;
  alphaRef: string;
  alphadigiref: string | null;
  comments: string;
  description: string;
  digiRef: string;
  gradeId: number;
  gradeid: number;
  ideduserv: number;
  isdeleted: boolean;
}

export interface GradeApiResponse {
  error: string | null;
  response: GradeResponseContent;
}

@Injectable({
  providedIn: 'root',
})
export class KissatiService {
  
  private baseUrl = environment.apiUrl + '/grade/getById/';
  private baseUrlkissati = 'https://9issati.net/mobile/9issati/perAge/';

  constructor(private http: HttpClient) {}

  getDigiref(gradeId: number): Observable<number> {
    const url = `${this.baseUrl}${gradeId}`;
    return this.http.get<GradeApiResponse>(url).pipe(
      map(apiResponse => {
        const parsedDigiref = parseInt(apiResponse.response.digiRef);
        return isNaN(parsedDigiref) ? 0 : parsedDigiref;
      })
    );
  }

  getBooksByDigiref(
    grade: number,
    pageNumber: number = 1,
    pageSize: number = 10
  ): Observable<BookResponse[]> {
    const url = `${this.baseUrlkissati}${grade}/${pageNumber}/${pageSize}`;
    console.log('Requesting books with URL:', url);
    return this.http.get<BookResponse[]>(url);
  }

  searchBooks(digiref: number, text: string): Observable<BookModel> {
    const url = 'https://9issati.net/mobile/9issati/search';
    const parameter = {
      digiref: digiref,
      text: text,
    };

    return this.http.post<BookModel>(url, parameter);
  }
}